var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4485_36497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32C32 29.8783 32.8429 27.8434 34.3431 26.3431C35.8434 24.8429 37.8783 24 40 24C42.1217 24 44.1566 24.8429 45.6569 26.3431C47.1571 27.8434 48 29.8783 48 32C48 34.1217 47.1571 36.1566 45.6569 37.6569C44.1566 39.1571 42.1217 40 40 40C37.8783 40 35.8434 39.1571 34.3431 37.6569C32.8429 36.1566 32 34.1217 32 32Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 48C16 45.8783 16.8429 43.8434 18.3431 42.3431C19.8434 40.8429 21.8783 40 24 40H32V48C32 50.1217 31.1571 52.1566 29.6569 53.6569C28.1566 55.1571 26.1217 56 24 56C21.8783 56 19.8434 55.1571 18.3431 53.6569C16.8429 52.1566 16 50.1217 16 48V48Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 8V24H40C42.1217 24 44.1566 23.1571 45.6569 21.6569C47.1571 20.1566 48 18.1217 48 16C48 13.8783 47.1571 11.8434 45.6569 10.3431C44.1566 8.84285 42.1217 8 40 8H32Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16C16 18.1217 16.8429 20.1566 18.3431 21.6569C19.8434 23.1571 21.8783 24 24 24H32V8H24C21.8783 8 19.8434 8.84285 18.3431 10.3431C16.8429 11.8434 16 13.8783 16 16V16Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C16 34.1217 16.8429 36.1566 18.3431 37.6569C19.8434 39.1571 21.8783 40 24 40H32V24H24C21.8783 24 19.8434 24.8429 18.3431 26.3431C16.8429 27.8434 16 29.8783 16 32V32Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4485_36497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 48,
    fill: "white",
    transform: "translate(16 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.817a11865de919b4e76c34a5ac9afad1.svg";
export { ForwardRef as ReactComponent };